import { Component, HostListener, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { OrderService } from '../../_services/order.service';
import { breakpointPixels, FadvContentComponent, FadvTooltipComponent, FadvTooltipContentComponent } from '@fa-switch-sharedservices/ng-elements';

@Component({
  selector: 'app-candidateinvite',
  templateUrl: './candidateinvite.component.html',
  styleUrls: ['./candidateinvite.component.less']
})
export class CandidateinviteComponent implements OnInit {

  firstNameAlignment: string = "left";
  lastNameAlignment: string = "right";
  emailAlignment: string = "left";
  confirmEmailAlignment: string = "right";
  innerWidth: number = window.innerWidth;

  @Input() candidateinvite: UntypedFormGroup;
  emailInvalid: boolean;
  confirmEmailInvalid: boolean;
  firstNameInvalid: boolean;
  lastNameInvalid: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private orderService: OrderService) { }

    @HostListener('window:resize', ['$event'])

    onResize(event){
        this.innerWidth = window.innerWidth;
        this.handleViewChange();
    }

    handleViewChange() : void {
      if (this.innerWidth <= breakpointPixels.md) 
      {
        this.firstNameAlignment = "left";
        this.lastNameAlignment = "left";
        this.emailAlignment = "left";
        this.confirmEmailAlignment = "left";
      } 
      else
      {
        this.firstNameAlignment = "left";
        this.lastNameAlignment = "right";
        this.emailAlignment = "left";
        this.confirmEmailAlignment = "right";
      }
    }

  ngOnInit(): void {
    this.emailInvalid = false;
    this.confirmEmailInvalid = false;
    this.firstNameInvalid = false;
    this.lastNameInvalid = false;

    if (window.innerWidth <= breakpointPixels.md) 
    {
      this.firstNameAlignment = "left";
      this.lastNameAlignment = "left";
      this.emailAlignment = "left";
      this.confirmEmailAlignment = "left";
    } 
    else
    {
      this.firstNameAlignment = "left";
      this.lastNameAlignment = "right";
      this.emailAlignment = "left";
      this.confirmEmailAlignment = "right";
    }
  }

  showValidation(field: string){
    if(this.candidateinvite.controls[field].invalid && this.candidateinvite.controls[field].dirty){
        this[field+"Invalid"] = true;
    }
    else{
        this[field+"Invalid"] = false;
    }
}
}
